import React from "react";
import { Row, Col, Typography, Checkbox } from "antd";
import { useTranslation } from "react-i18next";
import {
  EmployeeFollowUpEventQuizStatus,
  AnsweredBy,
  QuizAnsweredBy,
  NotApplicableSuffix,
  NotApplicableLabel,
} from "../common/GeneralConfigurations";
import "./EmployeeFollowUpEventDetailListForm.css";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";

const { Text } = Typography;

const QuizQuestionMultipleChoiceForm = ({
  quizIsAnsweredBy,
  quizStatusId,
  readonly,
  quizLanguage,
  answeredBy,
  questionText,
  isRequired,
  allowNotApplicable,
  questionDomainOptions,
  minValue,
  errorMessage,
  fieldName,
  consultantAnswer,
  consultantAllowNotApplicableAnswer,
  supervisorAnswer,
  supervisorAllowNotApplicableAnswer,
  handleSelectChange,
  onNotApplicable,
  isReadOnly,
  onBlur,
}) => {
  const { t } = useTranslation();
  const isNotApplicable = true;

  const getDomainOptionsValues = (options, selectedValues) => {
    const selectedOptions = [];
    if (selectedValues) {
      if (!Array.isArray(selectedValues)) {
        selectedValues = selectedValues.split(",").map(Number);
      }
      selectedValues.forEach((selected) => {
        options.forEach((op) => {
          if (selected.answer == op.id || selected == op.id) {
            selectedOptions.push(op.id);
          }
        });
      });
    }
    return selectedOptions;
  };
  const getSeletedOptionsValues = (options, selectedValues) => {
    let selectedOptions = [];
    if (selectedValues) {
      if (!Array.isArray(selectedValues)) {
        selectedValues = selectedValues.split(",").map(Number);
      }
      selectedValues.forEach((selected) => {
        options.forEach((op) => {
          if (selected.answer == op.id || selected == op.id) {
            selectedOptions.push(op.name);
          }
        });
      });
    }
    return selectedOptions;
  };
  const getCheckboxOptions = (options) => {
    let domainOptions = [];
    options &&
      options.map((op) => {
        domainOptions.push({
          value: op.id,
          label: op.name,
        });
      });
    return domainOptions;
  };

  return (
    <>
      {/* Consultant view or Supervisor view and wating for consultant answer */}
      {quizStatusId ===
        EmployeeFollowUpEventQuizStatus.AwaitsResponseFromConsultant && (
        // (answeredBy === AnsweredBy.Consultant || answeredBy === AnsweredBy.Both) &&
        <div className="quiz-question-person">
          <Row className="question-title">
            <Text type="danger">{isRequired ? "* " : ""}</Text>
            <AdnTextArea placeholder={questionText} disabled autoSize />
          </Row>

          <p>
            {t("quizQuestionMultipleChoice.chooseOptions", { count: minValue })}
          </p>
          <Row>
            <Col>
              <p className="quiz-element-margin">
                <Checkbox.Group
                  name={fieldName}
                  options={getCheckboxOptions(questionDomainOptions)}
                  disabled={isReadOnly(
                    allowNotApplicable === true
                      ? consultantAllowNotApplicableAnswer
                      : false
                  )}
                  className="quiz-checkbox"
                  value={supervisorAnswer}
                  onChange={(e) => handleSelectChange(e, fieldName)}
                  defaultValue={getDomainOptionsValues(
                    questionDomainOptions,
                    consultantAnswer
                  )}
                />
              </p>
              {allowNotApplicable === true && (
                <p className="quiz-element-margin">
                  <Checkbox
                    name={fieldName + NotApplicableSuffix}
                    defaultChecked={consultantAllowNotApplicableAnswer}
                    checked={consultantAllowNotApplicableAnswer}
                    onChange={(value) => onNotApplicable(value, fieldName)}
                    disabled={readonly}
                  >
                    {NotApplicableLabel}
                  </Checkbox>
                </p>
              )}
              {errorMessage && <Text type="danger">{errorMessage}</Text>}
            </Col>
          </Row>
        </div>
      )}
      {/* Supervisor view for regular type events, that are answered only by the supervisor */}
      {quizIsAnsweredBy === QuizAnsweredBy.Supervisor &&
        quizStatusId ===
          EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor &&
        (answeredBy === AnsweredBy.Supervisor ||
          answeredBy === AnsweredBy.Both) && (
          <>
            {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} {minValue}</p> */}
            <Row className="question-title">
              <Text type="danger">{isRequired ? "* " : ""}</Text>
              <AdnTextArea placeholder={questionText} disabled autoSize />
            </Row>

            <p>
              {t("quizQuestionMultipleChoice.chooseOptions", {
                count: minValue,
              })}
            </p>
            <Row>
              <Col>
                <p className="quiz-element-margin">
                  <Checkbox.Group
                    name={fieldName}
                    options={getCheckboxOptions(questionDomainOptions)}
                    disabled={isReadOnly(
                      allowNotApplicable === true
                        ? supervisorAllowNotApplicableAnswer
                        : false
                    )}
                    className="quiz-checkbox"
                    value={supervisorAnswer}
                    onChange={(e) => handleSelectChange(e, fieldName)}
                    defaultValue={getDomainOptionsValues(
                      questionDomainOptions,
                      supervisorAnswer
                    )}
                  />
                </p>
                {allowNotApplicable === true && (
                  <p className="quiz-element-margin">
                    <Checkbox
                      name={fieldName + NotApplicableSuffix}
                      defaultChecked={supervisorAllowNotApplicableAnswer}
                      checked={supervisorAllowNotApplicableAnswer}
                      onChange={(value) => onNotApplicable(value, fieldName)}
                      disabled={readonly}
                    >
                      {NotApplicableLabel}
                    </Checkbox>
                  </p>
                )}
                {errorMessage && <Text type="danger">{errorMessage}</Text>}
              </Col>
            </Row>
          </>
        )}
      {/* Supervisor view for evaluation type events */}
      {quizIsAnsweredBy === QuizAnsweredBy.Consultant &&
        quizStatusId ===
          EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor && (
          <>
            {/* consultant answer */}
            {(answeredBy === AnsweredBy.Consultant ||
              answeredBy === AnsweredBy.Both) && (
              <>
                {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} {minValue}</p> */}
                <Row className="question-title">
                  <Text type="danger">{isRequired ? "* " : ""}</Text>
                  <AdnTextArea placeholder={questionText} disabled autoSize />
                </Row>

                {allowNotApplicable === true &&
                consultantAllowNotApplicableAnswer === isNotApplicable ? (
                  <>
                    <b style={{ color: "var(--adnblue)" }}>
                      {t("quizQuestionMultipleChoice.consultant")}
                    </b>{" "}
                    <p className="quiz-not-applicable">{NotApplicableLabel}</p>
                  </>
                ) : (
                  <Row>
                    <Col>
                      {consultantAllowNotApplicableAnswer !==
                        isNotApplicable && (
                        <Row>
                          <p>
                            <b style={{ color: "var(--adnblue)" }}>
                              {t("quizQuestionMultipleChoice.consultant")}&nbsp;
                            </b>
                          </p>

                          {getSeletedOptionsValues(
                            questionDomainOptions,
                            consultantAnswer
                          ).map((op) => {
                            return (
                              <Col>
                                <p className="answser-options">
                                  {op}&nbsp;&nbsp;
                                </p>
                              </Col>
                            );
                          })}
                        </Row>
                      )}
                    </Col>
                  </Row>
                )}
              </>
            )}
            {/* supervisor answer */}
            {(answeredBy === AnsweredBy.Supervisor ||
              answeredBy === AnsweredBy.Both) && (
              <div className="quiz-question-person">
                <Row className="question-title">
                  <Text type="danger">{isRequired ? "* " : ""}</Text>
                  <AdnTextArea placeholder={questionText} disabled autoSize />
                </Row>
                <p>
                  {t("quizQuestionMultipleChoice.chooseOptions", {
                    count: minValue,
                  })}
                </p>
                <Row>
                  <Col>
                    <p className="quiz-element-margin">
                      <Checkbox.Group
                        name={fieldName}
                        options={getCheckboxOptions(questionDomainOptions)}
                        disabled={isReadOnly(
                          allowNotApplicable === true
                            ? supervisorAllowNotApplicableAnswer
                            : false
                        )}
                        className="quiz-checkbox"
                        value={supervisorAnswer}
                        onChange={(e) => {
                          handleSelectChange(e, fieldName);
                          onBlur();
                        }}
                        defaultValue={getDomainOptionsValues(
                          questionDomainOptions,
                          supervisorAnswer
                        )}
                      />
                    </p>
                    {allowNotApplicable === true && (
                      <p className="quiz-element-margin">
                        <Checkbox
                          name={fieldName + NotApplicableSuffix}
                          defaultChecked={supervisorAllowNotApplicableAnswer}
                          checked={supervisorAllowNotApplicableAnswer}
                          onChange={(value) =>
                            onNotApplicable(value, fieldName)
                          }
                          disabled={readonly}
                        >
                          {NotApplicableLabel}
                        </Checkbox>
                      </p>
                    )}
                    {errorMessage && <Text type="danger">{errorMessage}</Text>}
                  </Col>
                </Row>
              </div>
            )}
          </>
        )}
      {/* when quiz is answered */}
      {quizStatusId === EmployeeFollowUpEventQuizStatus.Answered && (
        <>
          <Row className="question-title">
            <Text type="danger">{isRequired ? "* " : ""}</Text>
            <AdnTextArea placeholder={questionText} disabled autoSize />
          </Row>
          {/* consultant answer */}
          {(consultantAnswer || consultantAllowNotApplicableAnswer) &&
          consultantAllowNotApplicableAnswer === isNotApplicable ? (
            <Row>
              <p>
                <b style={{ color: "var(--adnblue)" }}>
                  {t("quizQuestionMultipleChoice.consultant")}&nbsp;
                </b>
              </p>
              <Text type="warning" className="quiz-not-applicable">
                {NotApplicableLabel}
              </Text>
            </Row>
          ) : (
            <Row>
              {consultantAnswer && (
                <>
                  <p>
                    <b style={{ color: "var(--adnblue)" }}>
                      {t("quizQuestionMultipleChoice.consultant")}&nbsp;
                    </b>
                  </p>

                  {getSeletedOptionsValues(
                    questionDomainOptions,
                    consultantAnswer
                  ).map((op) => {
                    return (
                      <Col>
                        <p className="answser-options">{op}&nbsp;&nbsp;</p>
                      </Col>
                    );
                  })}
                </>
              )}
            </Row>
          )}

          {/* supervisor answer */}
          {(supervisorAnswer || supervisorAllowNotApplicableAnswer) &&
            (supervisorAllowNotApplicableAnswer === isNotApplicable ? (
              <Row>
                <p>
                  <b className="answer-supervisor answser-options">
                    {t("quizQuestionMultipleChoice.supervisor")}&nbsp;
                  </b>
                </p>
                <Text type="warning" className="quiz-not-applicable">
                  {NotApplicableLabel}
                </Text>
              </Row>
            ) : (
              <Row>
                <p>
                  <b className="answer-supervisor answser-options">
                    {t("quizQuestionMultipleChoice.supervisor")}&nbsp;
                  </b>
                </p>

                {getSeletedOptionsValues(
                  questionDomainOptions,
                  supervisorAnswer
                ).map((op) => {
                  return (
                    <Col>
                      <p className="answser-options">{op}&nbsp;&nbsp;</p>
                    </Col>
                  );
                })}
              </Row>
            ))}
        </>
      )}
    </>
  );
};

export default QuizQuestionMultipleChoiceForm;
